import * as SwitchPrimitives from "@radix-ui/react-switch";
import * as React from "react";

import { cn } from "@/lib/utils";

type SwitchSize = "small" | "medium" | "large";

interface SwitchProps
  extends React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> {
  size?: SwitchSize;
}

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  SwitchProps
>(({ className, size = "medium", ...props }, ref) => {
  const getClass = (size: SwitchSize): string => {
    switch (size) {
      case "small":
        return "h-4 w-8";
      case "medium":
        return "h-6 w-11";
      case "large":
        return "h-7 w-12";
      default:
        return "h-6 w-11";
    }
  };

  const getThumbClass = (size: SwitchSize): string => {
    switch (size) {
      case "small":
        return "h-2.5 w-2.5";
      case "medium":
        return "h-5 w-5";
      case "large":
        return "h-6 w-6";
      default:
        return "h-5 w-5";
    }
  };

  return (
    <SwitchPrimitives.Root
      className={cn(
        `peer inline-flex ${getClass(size)} shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input`,
        className,
      )}
      {...props}
      ref={ref}
    >
      <SwitchPrimitives.Thumb
        className={cn(
          `pointer-events-none block ${getThumbClass(size)}  rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 ${size === "small" && "data-[state=checked]:translate-x-4"} data-[state=unchecked]:translate-x-0`,
        )}
      />
    </SwitchPrimitives.Root>
  );
});
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
